import { Component, OnInit, DoCheck, PLATFORM_ID, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NoteService } from 'src/app/services/note.service';
import { UserService } from 'src/app/services/user.service';
import { CategoryService } from 'src/app/services/category.service';
import { isPlatformBrowser } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit, DoCheck {
  recentNotes = [];
  popularNotes = [];
  categoriesItems: any[];
  arangersList = [];
  isLoading = true;

  constructor(
    private router: Router,
    private noteService: NoteService,
    private categoryService: CategoryService,
    private userService: UserService,
    private title: Title,
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.categoryService.getCategories().subscribe((catResp) => {
      this.categoriesItems = catResp.data;
    });

    this.userService.getAllArrangers().subscribe((arrResp) => {
      this.arangersList = arrResp.data.arrangers;
      this.fetchNotes();
    });

    this.translateService.get('title_home').subscribe({
      next: (e) => {
        this.title.setTitle(this.translateService.instant(e));
      }
    });
    
  }

  ngDoCheck() {
    if (isPlatformBrowser(this.platformId)) {
      const widthButtonCategories = document.getElementById('categoriesBtn').offsetWidth;
      const elems = Array.from(document.getElementsByClassName('mat-menu-panel') as HTMLCollectionOf<HTMLElement>);

      for (var i = 0; i < elems.length; i++) {
        elems[i].style.width = widthButtonCategories + 'px';
      }
    }
  }

  public goToSearch() {
    this.router.navigate(['/szukaj']);
  }

  private fetchNotes() {
    this.noteService.getNotesRecentPopular().subscribe(response => {
      if (response.success) {
        this.recentNotes = response.data.recentNotes;
        this.popularNotes = response.data.popularNotes;
      }
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      // this.httpAlertService.error(err.error.message);
    });
  }

  public searchTrack(event) {
    this.router.navigate(['/szukaj'], { queryParams: { text: event.target.value } });
  }

  public handlecategoryItemClick(item) {
    this.router.navigate(['/szukaj'], { queryParams: { category: item.name } });
  }

}
